import { Component, input, output } from '@angular/core';
import { ClientPaymentSummary } from '../../models';
import { Currency, DEFAULT_CURRENCY } from '@aiwyn/api';
import { ConfigService, LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';

export interface ClientPaymentSummaryItemToggledEvent {
  clientId: number;
  isOn: boolean;
}

@Component({
  selector: 'app-client-payment-summary',
  templateUrl: './client-payment-summary.component.html',
  styleUrls: ['./client-payment-summary.component.scss'],
  standalone: false,
})
export class ClientPaymentSummaryComponent {
  paymentSummaryInput = input<ClientPaymentSummary>(undefined, { alias: 'paymentSummary' });
  currency = input<Currency>(DEFAULT_CURRENCY);

  invoicesRemoved = output<number>();
  prepaymentsRemoved = output<number>();
  payLateFeeChange = output<ClientPaymentSummaryItemToggledEvent>();
  creditAppliedChange = output<ClientPaymentSummaryItemToggledEvent>();
  addOnRemoved = output<number>();

  isPayLateFeesByClientEnabled$ = this.launchDarklyService.getFeatureFlag(LaunchDarklyFlag.ENABLE_APPLY_CREDITS_TO_LATE_FEES);

  constructor(
    readonly configService: ConfigService,
    private readonly launchDarklyService: LaunchDarklyService,
  ) {}

  onPayLateFeeChange(checked: boolean): void {
    if (this.configService.paymentLateFeeRequired) {
      return;
    }

    this.payLateFeeChange.emit({
      clientId: this.paymentSummaryInput().client.id,
      isOn: checked,
    });
  }

  onCreditAppliedChange(checked: boolean): void {
    this.creditAppliedChange.emit({
      clientId: this.paymentSummaryInput().client.id,
      isOn: checked,
    });
  }
}
